var map = {
	"./aboard.svg": "5f7b",
	"./course.svg": "71c5",
	"./course1.svg": "8d78",
	"./member.svg": "daf4",
	"./package.svg": "f5e6",
	"./password.svg": "2a3d",
	"./resource.svg": "ac7b",
	"./student.svg": "9afa",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";